export default class OrderItem {
    constructor(orderItem, productPrice, changeQuantityEvent = true) {
        if (!orderItem) {
            return;
        }

        productPrice = productPrice || orderItem?.querySelector('[data-ui-el="product-price"]');

        if (!productPrice) {
            return;
        }

        this.productPrice = parseInt(productPrice.textContent, 10) || 0;
        this.productId = orderItem.dataset.id || null;
        this.orderItem = orderItem;
        this.productQuantity = 1;
        this.userCoins = 0;
        this.currentSize = null;
        this.sizeList = null;
        this.maxQuantity = 'Infinity';
        this.currency = orderItem.dataset.currency;

        this.quantityDom = {
            input: orderItem.querySelector('[data-ui-el="quantity-input"]'),
            decreaseBtn: orderItem.querySelector('[data-ui-el="quantity-decrease"]'),
            increaseBtn: orderItem.querySelector('[data-ui-el="quantity-increase"]'),
        };

        this.currencyRadioButtons = orderItem.querySelectorAll('[data-currency-radiobtn]');

        this.initSize();
        this.getInputQuantity();
        this.checkQuantityValue();

        if (changeQuantityEvent) {
            this.changeQuantityEvent();
        }
    }

    /**
     *@return {Number}
     */
    getInputQuantity() {
        if (!this.quantityDom.input) {
            this.productQuantity = 1;
            return this.productQuantity;
        }

        this.productQuantity = parseInt(this.quantityDom.input.value, 10);

        if (this.productQuantity < 1 || !Number.isFinite(this.productQuantity)) {
            this.productQuantity = 1;
        }

        return this.productQuantity;
    }

    /**
     *@param {Number} value
     */
    setInputQuantity(value = this.productQuantity) {
        if (!this.quantityDom.input) {
            return;
        }

        if (!Number.isFinite(value)) {
            this.quantityDom.input.value = 1;
            return;
        }

        this.quantityDom.input.value = value;
    }

    checkQuantityValue() {
        if (!this.quantityDom.increaseBtn || !this.quantityDom.decreaseBtn) {
            return;
        }

        this.quantityDom.increaseBtn.removeAttribute('disabled');
        this.quantityDom.decreaseBtn.removeAttribute('disabled');

        if (this.productQuantity <= 1) {
            this.productQuantity = 1;
            this.quantityDom.decreaseBtn.setAttribute('disabled', '');
        }

        if (this.productQuantity >= this.maxQuantity) {
            this.productQuantity = this.maxQuantity;
            this.quantityDom.increaseBtn.setAttribute('disabled', '');

            if (this.productQuantity <= 1) {
                this.productQuantity = 1;
                this.quantityDom.decreaseBtn.setAttribute('disabled', '');
            }
        }

        this.setInputQuantity();
    }

    quantityIncrease() {
        this.productQuantity += 1;
    }

    quantityDecrease() {
        this.productQuantity -= 1;
    }

    /**
     *@param {Function} callback
     */
    changeQuantityEvent(callback = null) {
        if (
            !this.quantityDom.increaseBtn ||
            !this.quantityDom.decreaseBtn ||
            !this.quantityDom.input ||
            !this.currencyRadioButtons
        ) {
            return;
        }

        this.quantityDom.decreaseBtn.addEventListener('click', () => {
            this.getInputQuantity();
            this.quantityDecrease();

            if (callback) {
                return callback();
            }

            this.checkQuantityValue();
        });

        this.quantityDom.increaseBtn.addEventListener('click', () => {
            this.getInputQuantity();
            this.quantityIncrease();

            if (callback) {
                return callback();
            }

            this.checkQuantityValue();
        });

        this.quantityDom.input.addEventListener('change', () => {
            this.getInputQuantity();

            if (callback) {
                return callback();
            }

            this.checkQuantityValue();
        });

        this.currencyRadioButtons.forEach((item) => item.addEventListener('change', (e) => {
            if (!e.target.checked) {
                return;
            }

            this.currency = e.target.value;

            if (callback) {
                return callback();
            }
        }));
    }

    /**
     *@param {Number} maxQuantity
     */
    setMaxQuantity(maxQuantity) {
        this.maxQuantity = maxQuantity || 'Infinity';

        if (Number.isFinite(maxQuantity) && this?.quantityDom?.input?.max) {
            this.quantityDom.input.max = maxQuantity;
        }

        this.checkQuantityValue();
    }

    /**
     * @param {Object} prices
     */
    setPrices(prices) {
        const price = this.orderItem?.querySelector('[data-element="price"]');
        const submitButton = document.querySelector('[data-ui-el="add-cart-btn"]');
        const oldPrice = this.orderItem?.querySelector('[data-element="old_price"]');
        const priceUahBlock = this.orderItem?.querySelector('[data-element="price_uah_block"]');
        const priceUah = this.orderItem?.querySelector('[data-element="price_uah"]');
        const oldPriceUah = this.orderItem?.querySelector('[data-element="old_price_uah"]');
        const balance = parseInt(document.querySelector('[data-ui-el="user-coins"]')?.innerHTML, 10) || 0;
        const priceCheck = this.orderItem?.querySelector('[data-check-order]');
        const minPrice = Math.min(...[prices.price, prices.specialPrice].filter(value => value > 0));

        priceCheck.dataset.checkOrder = balance < minPrice;

        if (balance >= minPrice) {
            submitButton?.removeAttribute('disabled');
        } else {
            submitButton?.setAttribute('disabled', '');
        }

        if (price) {
            price.textContent = prices.price;
        }

        if (prices.specialPrice) {
            if (oldPrice) {
                oldPrice.textContent = prices.price;
                oldPrice.hidden = false;
            }

            if (price) {
                price.textContent = prices.specialPrice;
            }
        } else if (oldPrice) {
            oldPrice.hidden = true;
        }

        if (prices.priceUah) {
            priceUah.textContent = prices.priceUah;
            priceUahBlock.style.display = 'flex';
            priceUah.hidden = false;
            submitButton?.removeAttribute('disabled');

            if (balance < minPrice) {
                priceUah.click();
            }

            if (prices.specialPriceUah) {
                oldPriceUah.textContent = prices.priceUah;
                priceUah.textContent = prices.specialPriceUah;
                oldPriceUah.hidden = false;
            } else {
                oldPriceUah.hidden = true;
            }
        } else {
            priceUah.hidden = true;
            priceUahBlock.style.display = 'none';
            oldPriceUah.hidden = true;
        }
    }

    setCurrentSize(sizeItem) {
        if (!sizeItem || !sizeItem.checked) {
            return;
        }

        this.currentSize = {
            id: sizeItem.id,
            quantity: parseInt(sizeItem.dataset.quantity, 10) || Infinity,
            inCart: (sizeItem.dataset.inCart === '1'),
            element: sizeItem,
            prices: JSON.parse(sizeItem.dataset.prices),
        };
    }

    /**
     *@param {Element} input
     *@param {Function} callback
     */
    changeSizeEvent(input, callback) {
        if (this.currentSize.id === 'one-size') {
            return;
        }

        input.addEventListener('change', () => {
            if (!input.checked) {
                return;
            }

            this.setCurrentSize(input);
            this.setMaxQuantity(this.currentSize.quantity);
            this.setPrices(this.currentSize.prices);
            callback(this.currentSize.inCart);
        });
    }

    initSize() {
        const sizeList = this.orderItem.querySelectorAll('[data-ui-el="product-sizes"] input[type="radio"]');
        const oneSize = this.orderItem.querySelector('[data-size="one-size"]') || null;

        if (!sizeList.length && !oneSize) {
            return;
        }

        if (oneSize) {
            this.currentSize = {
                id: 'one-size',
                inCart: !!oneSize.dataset.inCart,
                element: oneSize,
            };

            this.setMaxQuantity(parseInt(oneSize.dataset.quantity, 10));

            return;
        }

        this.sizeList = sizeList;
        this.setCurrentSize(Array.from(sizeList).find((item) => item.checked));
        this.setMaxQuantity(this.currentSize.quantity);
        this.setPrices(this.currentSize.prices);
    }
}
